import { Zod } from "@workspace/core";
import { z } from "zod";

import { zLanguageCode } from "../i18n";

const { zFromJson, zEmptyString } = Zod;

const zQuantity = z.number().int().nonnegative().brand("Quantity");
type Quantity = z.infer<typeof zQuantity>;

const RELATIVE_PERCENT_CONSTRAINTS = {
  value: {
    minimum: -100,
    maximum: 100,
  },
};

const zRelativePercent = z
  .number()
  .min(RELATIVE_PERCENT_CONSTRAINTS.value.minimum)
  .max(RELATIVE_PERCENT_CONSTRAINTS.value.maximum)
  .brand("RelativePercent");
type RelativePercent = z.infer<typeof zRelativePercent>;

const zWithLanguage = z.object({
  languageCode: zLanguageCode,
});

export {
  RELATIVE_PERCENT_CONSTRAINTS,
  zEmptyString,
  zFromJson,
  zQuantity,
  zRelativePercent,
  zWithLanguage,
};
export type { Quantity, RelativePercent };
